module.exports = __webpack_public_path__ + "img/guideThree.f954cfa5.png";